import authAxios from '@/auth/auth-axios';
import ProjectSchemaPresenter from './project-schema-presenter';
import * as Sentry from '@sentry/browser';

export default class ProjectService {
  static async find(id) {
    const axios = await authAxios();
    const response = await axios.get(`/project/${id}`);
    return this.map(response.data);
  }

  static async destroy(id) {
    const axios = await authAxios();
    await axios.delete(`/project/${id}`);
  }

  static async listRecent() {
    const axios = await authAxios();
    const response = await axios.get(`/project/recent`);
    return this.map(response.data);
  }

  static async listCreditsEarned() {
    const axios = await authAxios();
    const response = await axios.get(
      `/project/creditsEarned`,
    );
    return this.map(response.data);
  }

  static async purchase(id) {
    const axios = await authAxios();
    const response = await axios.post(
      `/project/${id}/purchase`,
    );
    return this.map(response.data);
  }

  static async refreshAndGetPreviewUrl(buildId) {
    try {
      const axios = await authAxios();
      const response = await axios.post(
        `/preview/${buildId}`,
      );
      return response.data;
    } catch (error) {
      Sentry.captureException(error);
      return null;
    }
  }

  static map(arg) {
    if (!arg) {
      return null;
    }

    if (Array.isArray(arg)) {
      return arg.map((item) => this.map(item));
    }

    arg.presenter = new ProjectSchemaPresenter(
      arg.scaffold,
      arg.schema,
    );

    return arg;
  }

  static async updateLabel(id, label) {
    const axios = await authAxios();

    const response = await axios.put(
      `/project/${id}/label`,
      {
        label,
      },
    );

    return response.data;
  }
}
